import { render } from "./ProjectCommentActions.vue?vue&type=template&id=c6f0e62e"
import script from "./ProjectCommentActions.vue?vue&type=script&lang=js"
export * from "./ProjectCommentActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__